import { useAreParamsIdsValid } from "@/utils/hooksUtils";
import { ReactElement } from "react";
import { NotFound } from "../../../app/pages/NotFound";
import { TopAgentType } from "../../../common/enums";
import { Permission } from "../../../common/security/enums";
import { hasAllPermissions, hasAnyPermission } from "../../../common/security/utils";
import { useCurrentAgentAccount, usePermissions } from "../hooks";

interface Props {
  component: ReactElement;
  permissions: Permission[];
  allowedTopAgents?: TopAgentType[];
  anyPermission?: boolean;
}

const PageWithPermission = ({ component, permissions, anyPermission, allowedTopAgents }: Props) => {
  const areParamsIdsValid = useAreParamsIdsValid();
  const accountPermissions = usePermissions();
  const topAgentType = useCurrentAgentAccount()?.agent.topAgentType;

  if (allowedTopAgents?.length && topAgentType && !allowedTopAgents.includes(topAgentType)) {
    return <NotFound />;
  }

  const shouldRender = anyPermission
    ? hasAnyPermission(accountPermissions, permissions)
    : hasAllPermissions(accountPermissions, permissions);

  return areParamsIdsValid && shouldRender ? component : <NotFound />;
};

export default PageWithPermission;
